import { render, staticRenderFns } from "./ModelRecordDialog.vue?vue&type=template&id=2dc1b994&scoped=true&"
import script from "./ModelRecordDialog.vue?vue&type=script&lang=js&"
export * from "./ModelRecordDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc1b994",
  null
  
)

export default component.exports